export const qaConfig = () => {
    return {
        environment: 'qa',
        domain: 'https://uat.ils.labels.click/',
        hostname: 'https://uat.ils.labels.click',
        albURL: 'Reebok-Labeling-FE-Test-ALB-2136871295.us-east-2.elb.amazonaws.com',
        gateway: 'https://q790b8ewp5.execute-api.us-east-2.amazonaws.com',
        gatewayPath: '/test/labelling',
        oneLogin: {
            authority: "https://galaxycorp.onelogin.com/oidc/2",
            loginURL: "https://galaxycorp.onelogin.com/",
            logout: "https://galaxycorp.onelogin.com/oidc/2/logout",
            clientId: "dc3de280-182f-013e-0f61-7567e2acaced242941",
            redirectURI: "https://uat.ils.labels.click/redirect"
        }
    }
}